import { useInfiniteQuery } from '@tanstack/react-query';
import { api } from '@/modules/common/api/index.ts';
import {
  GetRegisterUsersResponse,
  GetRegisterUsersV1SrRegistersCurrentUsersGetParams,
} from 'api';

export const REGISTER_USERS_LIST_QUERY_KEY = 'vestra/register-users';

export const useRegisterUsersInfiniteQuery = (
  payload: GetRegisterUsersV1SrRegistersCurrentUsersGetParams,
  disabled = false,
  deps: unknown[] = [],
) => {
  const { page = 1, ...rest } = payload;

  return useInfiniteQuery<GetRegisterUsersResponse>({
    queryKey: [REGISTER_USERS_LIST_QUERY_KEY, rest.page_size, rest.name, ...deps],
    staleTime: 1000 * 60 * 60 * 3, // 3 hours
    retry: 2,
    enabled: !disabled,
    keepPreviousData: true,
    queryFn: async ({ pageParam }) => {
      const resolvedPage =
        typeof pageParam === 'number'
          ? pageParam || page
          : (pageParam as { page?: number })?.page || page;
      const searchTerm =
        typeof pageParam === 'number'
          ? rest.name
          : (pageParam as { search?: string })?.search ?? rest.name;

      const response = await api.v1.getRegisterUsersV1SrRegistersCurrentUsersGet({
        ...rest,
        name: searchTerm,
        page: resolvedPage,
      });
      const result = response.data as GetRegisterUsersResponse & { __search?: string };
      result.__search = searchTerm;
      return result;
    },
    getNextPageParam: lastPage => {
      const totalPages = Math.ceil(lastPage.total / lastPage.page_size);
      if (totalPages > lastPage.page) {
        return { page: lastPage.page + 1, search: (lastPage as any).__search };
      }
    },
  });
};
